$(function() {
    setTimeout(function () {
        $('#switcher').off('swipeLeft swipeRight');
    }, 100);
});
